export const orgKeys = {
  all: ["organization"] as const,
  profile: () => [...orgKeys.all, "profile"] as const,
  baselines: () => [...orgKeys.all, "baselines"] as const,
};

/** Explorer reads organization data, so every key carries the org id. */
export const explorerKeys = {
  all: ["explorer"] as const,
  home: (orgId: string | null | undefined) =>
    [...explorerKeys.all, orgId ?? null, "home"] as const,
  map: (orgId: string) => [...explorerKeys.all, orgId, "map"] as const,
  inventory: (
    orgId: string,
    resource: string,
    ids: readonly string[],
    query: object,
  ) =>
    [...explorerKeys.all, orgId, "inventory", resource, ...ids, query] as const,

  search: (orgId: string, query: string) =>
    [...explorerKeys.all, orgId, "search", query] as const,
  evaluateSearch: (orgId: string, query: string) =>
    [...explorerKeys.all, orgId, "evaluate", "search", query] as const,
  /** Refs in display order: the same items in another order are a different view. */
  compare: (orgId: string, refs: readonly string[]) =>
    [...explorerKeys.all, orgId, "evaluate", "compare", ...refs] as const,
};

export const adminKeys = {
  all: ["admin"] as const,
  organizations: () => [...adminKeys.all, "organizations"] as const,
  organization: (id: string) => [...adminKeys.all, "organization", id] as const,
  invitations: (id: string) =>
    [...adminKeys.all, "organization", id, "invitations"] as const,
};
